<button [ngClass]="class" type="type" [class.disabled]="isDisabled">
  <svg-icon *ngIf="icon" src="{{ icon }}"></svg-icon>
  {{ name }}
</button>
